import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ZoomInOutlinedSvg from "@ant-design/icons-svg/es/asn/ZoomInOutlined";
import AntdIcon from "../components/AntdIcon";
var ZoomInOutlined = function ZoomInOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ZoomInOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ZoomInOutlined.displayName = 'ZoomInOutlined';
}
export default /*#__PURE__*/React.forwardRef(ZoomInOutlined);